import { ButtonBase } from '@mui/material'
import CircularProgress from '@/global/components/CircularProgress'
import { CheckIcon, XIcon } from 'lucide-react'

interface IProps {
    tipo: 'aprovar' | 'reprovar'
    onClick: () => void
    isLoading?: boolean
    title?: string
}

export function ChipButton({
    tipo,
    onClick,
    isLoading = false,
    ...rest
}: IProps) {
    return (
        <ButtonBase
            onClick={onClick}
            sx={{
                borderRadius: '50%',
                width: '2rem',
                height: '2rem',
                padding: 0,
                margin: '0 0.5rem',
                backgroundColor:
                    tipo === 'aprovar' ? 'success.main' : 'error.main',
                color: 'white',
                boxShadow: 2,
            }}
            {...rest}
        >
            {isLoading ? (
                <CircularProgress size="1.5rem" />
            ) : tipo === 'aprovar' ? (
                <CheckIcon />
            ) : (
                <XIcon />
            )}
        </ButtonBase>
    )
}
